import { computed } from 'vue'
import { useToken } from '@/shared/composables/useToken'
import { useAppRouter } from '@/shared/composables/useAppRouter'
import { EPage } from '@/shared/enum/page.enum'

export const useClaroHeader = () => {
  const { msisdn, isProfiledToken } = useToken()
  const { currentRouteName, navigateToRoute } = useAppRouter()

  const pagesToHideWelcome = [EPage.LANDING, EPage.NOT_FOUND]
  const pagesToHideToggle = [EPage.LANDING, EPage.INVOICE, EPage.LATE_PAYMENT, EPage.NOT_FOUND]

  const shouldShowWelcomePhone = computed(() => {
    return !pagesToHideWelcome.includes(currentRouteName.value as EPage) && msisdn.value
  })

  const shouldShowSidebarToggle = computed(() => {
    return (
      !pagesToHideToggle.includes(currentRouteName.value as EPage) &&
      msisdn.value &&
      isProfiledToken.value
    )
  })

  const goToLandingPage = () => {
    navigateToRoute(EPage.LANDING)
  }

  return {
    msisdn,
    shouldShowWelcomePhone,
    shouldShowSidebarToggle,
    goToLandingPage
  }
}
